import React from 'react';
import titleImage from '../assets/images/item_196.jpg';

interface HeroProps {
    guestName: string;
    message: string;
}

const Hero: React.FC<HeroProps> = ({guestName, message}) => {
    return (
        <section
            className="relative flex justify-center items-center min-h-screen bg-no-repeat bg-center bg-cover"
            style={{backgroundImage: `url(${titleImage})`}}>
            <div className="hero-overlay absolute inset-0"/>
            <div className="relative z-10 px-6 max-w-2xl mx-auto">
                <div>
                    {guestName && (
                        <p className="font-sans text-xl tracking-[0.1em] text-white/90 mb-8 animate-fadeIn opacity-0 delay-300"
                           style={{textShadow: '0 0 30px rgba(0,0,0,1)'}}>
                            {guestName}
                        </p>
                    )}

                    <p className="font-sans text-sm tracking-[0.2em] uppercase text-white/90 mb-8 animate-fadeIn opacity-0 delay-300"
                       style={{textShadow: '0 0 10px rgba(0,0,0,1)'}}>
                        {message}
                    </p>
                </div>

                <div className="flex items-center justify-center gap-6 mb-6 animate-fadeIn opacity-0 delay-300">
                    <span className="block w-20 h-px bg-gradient-to-r from-transparent to-white/60"/>
                    <span className="text-gold text-xl animate-heart">✦</span>
                    <span className="block w-20 h-px bg-gradient-to-l from-transparent to-white/60"/>
                </div>

                <h1
                    className="font-script text-5xl md:text-8xl lg:text-9xl text-white mb-2 animate-fadeIn opacity-0 delay-400"
                    style={{textShadow: '2px 4px 20px rgba(0,0,0,0.3)', lineHeight: 1.1}}>
                    Aнастасия & Станислав
                </h1>

                <div className="flex items-center justify-center gap-5 mt-8 animate-fadeIn opacity-0 delay-500">
                    <span className="block w-12 md:w-20 h-px bg-white/40"/>
                    <span
                        className="font-serif text-sm md:text-lg text-white/90 tracking-[0.3em]"
                        style={{textShadow: '0 2px 8px rgba(0,0,0,0.3)'}}>
                        14 · 08 · 2026
                    </span>
                    <span className="block w-12 md:w-20 h-px bg-white/40"/>
                </div>

                <a
                    href="#rsvp"
                    className="btn-elegant inline-block mt-12 px-10 py-3.5 border border-white/60 text-white font-sans text-xs tracking-[0.35em] uppercase
                               hover:bg-white/15 hover:border-white active:scale-[0.97] transition-all duration-500 animate-fadeIn opacity-0 delay-700">
                    Подтвердить участие
                </a>
            </div>

            <div
                className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float opacity-0 animate-fadeIn delay-700">
                <svg width="20" height="30" viewBox="0 0 20 30" fill="none" className="text-white/50">
                    <rect x="1" y="1" width="18" height="28" rx="9" stroke="currentColor" strokeWidth="1.5"/>
                    <circle cx="10" cy="10" r="2" fill="currentColor" className="animate-bounce"/>
                </svg>
            </div>
        </section>
    );
};

export default Hero;

